import { UiSectionModel } from "../../models";

export function mockUiSectionModel({
    id = "section-1234",
    type = "uiSection",
    locale = "en",
    content = mockUiSectionModelContent()
}: Partial<UiSectionModel> = {}): UiSectionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSectionModelContent = UiSectionModel["content"];

export function mockUiSectionModelContent({
    ...optionals
}: Partial<UiSectionModelContent> = {}): UiSectionModelContent {
    return {
        ...optionals
    };
}
